import { render, staticRenderFns } from "./PvFrequency.vue?vue&type=template&id=0d70fd25&scoped=true&"
import script from "./PvFrequency.vue?vue&type=script&lang=js&"
export * from "./PvFrequency.vue?vue&type=script&lang=js&"
import style0 from "./PvFrequency.vue?vue&type=style&index=0&id=0d70fd25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70fd25",
  null
  
)

export default component.exports